export const CAPITAL_NEED_TYPES = [
  { value: 'replacement_same_unit', label: 'Replacement with the same unit' },
  { value: 'replacement_different_pn', label: 'Replacement with different P/N' },
  { value: 'upgrade', label: 'Upgrade' },
  { value: 'software_update', label: 'Software update' },
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'alternative_maintenance', label: 'Alternative Maintenance' },
  { value: 'additional_inspection', label: 'Additional inspection' },
  { value: 'special_ndt_inspection', label: 'Special (NDT) Inspection' },
  { value: 'service_bulletin_action', label: 'Service Bulletin Action' },
  { value: 'component_change', label: 'Component change' },
  { value: 'general_service_repair', label: 'General Service and Repair' },
] as const;

export const CAPITAL_NEED_STATUS = {
  DRAFT: { value: 'draft', label: 'Draft' },
  PLANNED: { value: 'planned', label: 'Planned' },
  PROCESSED: { value: 'processed', label: 'Processed' },
  REJECTED: { value: 'rejected', label: 'Rejected' },
};
export const CAPITAL_NEED_STATUSES = Object.values(CAPITAL_NEED_STATUS);
